import { createRoot } from 'react-dom/client';
import { store } from '@store/store';
import { dynamicImportL10N } from '@features/ui/UiSlice';
import { Provider } from 'react-redux';
import { useOption } from '@hooks/useOption';
import { App } from './App';

export const scheduleApp = async (options: IOption) => {
    try {
        const container = document.querySelector('#nc-schedule');
        const root = createRoot(container as Element);
        const option = useOption(options);
        const { meta, payload: l10nData } = await store?.dispatch(dynamicImportL10N());

        if(!option) {
            throw new Error('일정표를 사용하기 위한 필수 옵션 값이 존재하지 않습니다.');
        }

        if(meta?.requestStatus !== 'fulfilled' || !l10nData) {
            throw new Error('언어 파일이 로드되지 않았습니다.');
        }

        root.render(
            <Provider store={store}>
                <App />
            </Provider>
        );
    } catch(error) {
        console.error(error);
    }
};

window.ncSchedule = scheduleApp;